import type { Action } from "svelte/action";

/**
 *
 *
 *
 *
 *
 */
export const sheetFocusTrap: Action<
  HTMLElement,
  {
    hasBackButton: boolean;
    backButtonElement: HTMLElement;
    closeButtonElement: HTMLElement;
  }
> = (element, options) => {
  /*                                                       */
  if (import.meta.env.STORYBOOK && window.parent !== window.self) {
    /*                                      */
    return {};
  }

  function trap(): void {
    if (options.hasBackButton) {
      options.backButtonElement.focus();
      return;
    }

    options.closeButtonElement.focus();
  }

  element.addEventListener("transitionend", trap);

  return {
    update(parameter) {
      Object.assign(options, parameter);
    },
    destroy() {
      element.removeEventListener("transitionend", trap);
    },
  };
};

/**
 *
 *
 *
 *
 *
 *
 */
export const captureFocus: Action<HTMLDivElement, { hostElementVisible: boolean }> = (
  element,
  options,
) => {
  if (import.meta.env.STORYBOOK && window.parent !== window.self) {
    /*                                      */
    return {};
  }

  function focusIfNeeded(visible: boolean): void {
    if (visible) {
      element.focus();
    }
  }

  focusIfNeeded(options.hostElementVisible);

  return {
    update(parameter) {
      focusIfNeeded(parameter.hostElementVisible);
    },
  };
};
